import styled from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'
import { ProviderIcon } from '@root/entities/provider/ui'

import { PairActivitySnackbarBase } from './pair-activity-snackbar-base'

import type { PairActivity } from '../model'
import type { Provider } from '@root/entities/provider/model'

type Props = {
  activity: PairActivity.PoolMigrated
  onClose?: () => void
}

export const PairActivitySnackbarMigrated = ({ activity, onClose }: Props) => {
  return (
    <PairActivitySnackbarBase onClose={onClose} activity={activity}>
      <Group>
        <ProviderIcon provider={activity.from.dex} size={24} />{' '}
        <Label style={{ color: COLOR_MAP[activity.from.dex.id] }}>
          {activity.from.dex.title}
        </Label>
      </Group>
      <Separator />
      <Group>
        <CurrencyIcon currency={activity.currency} size={24} withNetwork />{' '}
        <Label>{activity.currency.title}</Label>
      </Group>
    </PairActivitySnackbarBase>
  )
}

const COLOR_MAP: Record<Provider.Id, string> = {
  ['orca']: '#FFD512',
  ['jupiter']: '#00D4AA',
  ['meteora-dyn']: '#ae5feb',
  ['meteora-dlmm']: '#ae5feb',
  ['raydium-v4']: '#a94ede',
  ['raydium-cpmm']: '#a94ede',
  ['raydium-clmm']: '#a94ede',
  ['raydium-launchpad']: '#a94ede',
  ['bonk-fun']: '#a94ede',
  ['uniswap-v2']: '#e44f97',
  ['uniswap-v3']: '#e44f97',
  ['dedust']: '#0098EA',
  ['pump-fun']: '#00D4AA',
  ['pump-swap']: '#00D4AA',
  ['deluge-vlmm']: '#00D4AA',
  ['pancakeswap-v1']: '#D1884F',
  ['pancakeswap-v2']: '#D1884F',
  ['pancakeswap-v3']: '#D1884F',
  ['stonfi-v1']: '#0098EA',
  ['stonfi-v2']: '#0098EA',
}

const Group = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
`

const Separator = styled.div`
  background: var(--backgroundA-4);
  width: 1px;
  height: 14px;
`

const Label = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`
